import { createContext, useContext, useState, useEffect, useCallback } from "react";
import translations from "../i18n/translations";

const LanguageContext = createContext();
const LANGS = ["de", "en", "fr", "it", "zh"];
const LANG_NAMES = { de: "Deutsch", en: "English", fr: "Francais", it: "Italiano", zh: "中文" };

function detectLang() {
  const b = navigator.language?.split("-")[0] || "de";
  return LANGS.includes(b) ? b : "de";
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const s = localStorage.getItem("hk_lang");
    return s && LANGS.includes(s) ? s : detectLang();
  });
  useEffect(() => { localStorage.setItem("hk_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = useCallback((k) => translations[lang]?.[k] || translations.en?.[k] || k, [lang]);
  const menuText = useCallback((item, field) => item[`${field}_${lang}`] || item[`${field}_en`] || "", [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t, menuText, LANGS, LANG_NAMES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
